import { useEffect, useState } from 'react';

const useNeonomicsSearchParams = () => {
  const [neonomicsParam, setNeonomicsParam] = useState(null);

  const updateParam = () => {
    const params = new URLSearchParams(window.location.search);
    const param = params.get('neonomics');
    setNeonomicsParam(param);
  };

  useEffect(() => {
    updateParam();
    const unlisten = window.HISTORY.listen(updateParam);
    return () => unlisten();
  }, []);

  return neonomicsParam;
};

export default useNeonomicsSearchParams;
